const cardMember = {
  seeMyCard: 'Voir ma carte',
  changeMyCard: 'Changer ma carte',
  addToMyWallet: 'Ajouter à mon {{brand}} Wallet',
  valueOfPoints: 'Valeur de {{amount}} $',
  pointsFamiliplus: 'Points Familiplus',
  nbrPoints: '{{count}} points',
  nbrPointsShort: '{{count}} pts',
  youHaveHarvested: 'Vous avez récolté',
  inTheLastXDays: 'dans les {{count}} derniers jours',
  rewards: 'Récompenses',
};

const staticBanner = {
  donation: 'Faire un don à Enfant Soleil',
  downloadApp: "Télécharger l'application mobile Familiprix",
  discoverFamiliplus: 'Découvrez en plus sur le programme avantage Familiplus',
};

const OES = {
  availablePoints: '{{points}} points ({{value}}$) disponibles',
  greeting: 'Faire un don à Enfant Soleil',
  howManyPoints: 'Combien de points désirez-vous donner?',
  pointsValue: 'Valeur du don en dollars: {{value}}$',
  consentLabel:
    'J’autorise Familiprix à faire le retrait en points de mon solde pour offrir sa valeur en dollars à Enfant Soleil.',
  taxLabel: "Notez qu’aucun reçu d'impôt ne sera remis suite à ce don.",
  legalTerms: 'Termes et conditions du programme Familiplus.',
  donate: 'Confirmer',
  consent: 'Vous devez donner votre consentement pour donner des points.',
  maxPoints: 'Vous ne pouvez pas donner plus de points que le nombre total de points sur votre carte.',
  minPoints: 'Vous devez saisir un nombre de points supérieur à 0',
  donationSuccess:
    'Merci pour votre don de {{points}} points / {{value}} dollars à Enfant Soleil. Votre soutien est vraiment apprécié!',
};

const transactions = {
  recentTitle: 'Transactions récentes',
  noResult: "Aucune transaction n'a été trouvée.",
  seeAll: 'Voir toutes les transactions',
  allTitle: 'Toutes mes transactions',
  backToSummary: 'Retour',
  fetchDataFailed:
    'Une erreur est survenue lors de la récupération de vos transactions. Veuillez réessayer dans quelques minutes. Si le problème persiste, veuillez contacter notre service à la clientèle à experienceclient@familiprix.com.',
};

const NotMember = {
  earnPointsWeekly: 'Gagnez des points chaque semaine!',
  weeklyDraw:
    "Profitez d'un tirage hebdomadaire de points via l'application Familiplus et courez la chance de gagner jusqu'à 10 000 points.",
  saveWithMemberPrice: 'Économisez grâce à nos Prix membre',
  getCompetitivePrice: 'Obtenez des prix avantageux, exclusivement pour les membres Familiplus.',
  accumulatePointsQuickly: 'Accumulez des points rapidement ',
  accumulatePointsEverywhere: 'Accumulez des points sur presque tous vos achats en succursale.',
  becomeMemberAndBenefit: 'Devenez membre Familiplus et profitez de pleins d’avantages',
  becomeMember: 'Devenez Membre',
  bigPlus: "C'est un gros plus",
  accumulatePointsAndStartEarning:
    'Accumulez des points sur presque tous vos achats et obtenez rapidement des dollars de récompenses. Créez ou complétez votre profil en quelques minutes!',

  seeAllBenefits: 'Voir tous les avantages',
};

const familiplusPage = {
  cardMember,
  staticBanner,
  OES,
  transactions,
  NotMember,
};

export default familiplusPage;
